import ActionTypes from '../constants';

const initialState = {
    vehicleModels: {},
    vehicleModel: {},
    newVehicleModel: {},
    VehicleModelByMake: {}
    // loading: false,
};

const vehicleModelReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETVEHICLEMODELSUCCESS:
            return {
                ...state,
                vehicleModels: action.payload,
            }
        case ActionTypes.GETVEHICLEMODELBYIDSUCCESS:
            return {
                ...state,
                vehicleModel: action.payload,
            }
        case ActionTypes.GETVEHICLEMODELBYMAKEIDSUCCESS:
            return {
                ...state,
                VehicleModelByMake: action.payload,
            }
        case ActionTypes.SAVEVEHICLEMODELSUCCESS:
            return {
                ...state,
                newVehicleModel: action.payload,
            }
        default:
            return state;
    }
}

export default vehicleModelReducer;